<template>
    <select :disabled="readonly" v-model="displayValue" class="form-control" title="Ações do Monitor">
        <option :value="null">SELECIONE UM MOTIVO</option>
        <option v-for="sn in rows" v-bind:key="sn._id" :value="sn._id">{{ sn.nome }}</option>
    </select>
</template>

<script>
import { AtendimentoMotivo } from "../../class/index";

export default {
    name: "ComboAtendimentoMotivo",
    props: {
        value: {
            default: null
        },
        readonly: {
            default: false
        }
    },
    data() {
        return {
            rows: []
        };
    },
    computed: {
        displayValue: {
            get: function() {
                return this.value;
            },
            set: function(modifiedValue) {
                this.$emit("input", modifiedValue);
            }
        }
    },
    beforeMount() {
        AtendimentoMotivo.all()
            .then(rows => {
                this.rows = rows;
            })
            .catch(err => console.error(err));
    }
};
</script>

<style scoped>
</style>
